import React from 'react';
import { Tag } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined, MinusCircleOutlined, StopOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { newStatus, NewStatus } from '../../utils/constants';
import './TagStatusNews.scss';

interface StatusTagProps {
    status: NewStatus;
    sheduleDayFrom: Date;
    sheduleDayTo?: Date | null;
}

const TagStatusNews: React.FC<StatusTagProps> = ({ status, sheduleDayFrom, sheduleDayTo }) => {
    const { t } = useTranslation();

    const isExpired = status === "active" && sheduleDayTo && moment().isAfter(moment(sheduleDayTo));
    const effectiveStatus: NewStatus = status;

    const tagLabel = () => {
        if (isExpired) return t("components.communications.status.expired");
        const statusObj = newStatus.find((s) => s.key === effectiveStatus);
        return statusObj ? t(statusObj.label) : '';
    };

    const tagIcon = () => {
        if (isExpired) return <StopOutlined className="icons-switch" />;
        switch (effectiveStatus) {
            case "active":
                return moment().isBefore(sheduleDayFrom)
                    ? <ClockCircleOutlined className="icons-switch" />
                    : <CheckCircleOutlined className="icons-switch" />;
            case "inactive":
                return <MinusCircleOutlined className="icons-switch" />;
            case "draft":
                return <ClockCircleOutlined className="icons-switch" />;
            default:
                return <></>;
        }
    };

    const tagColor = () => {
        if (isExpired) return "orange";
        if (effectiveStatus === "active") return "success";
        if (effectiveStatus === "draft") return "default";
        return "error";
    };

    return (
        <Tag className="tag-status-news" icon={tagIcon()} color={tagColor()}>
            {tagLabel()}
        </Tag>
    );
};

export default TagStatusNews;
